const styles = {
  image: {
    maxWidth: '200px'
  }
};

export default styles;
